import React from "react";

export const link = {
  render: "MarkdocLink",
  attributes: {
    href: { type: String },
    title: { type: String },
  },
};

/**
 * Link is a plain <a> tag but is configured to open in a new tab.
 */
export function MarkdocLink({
  href,
  title,
  children,
}: {
  href?: string;
  title?: string;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <a href={href} title={title} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
